export default __webpack_public_path__ + "static/media/loading_without_bg.976203f1.gif";